import { createMemo, Match, Switch } from "solid-js";
import type { TeamsCardProps, membersProps } from "../_model";
import { request } from "../apis";
import { global } from ":shared/app";
import { Button } from ":ui/form";
import { ImagesStacked } from "../../SHARED/components";

export default function TeamsCard(props: TeamsCardProps) {
  const track = global.store.actions.flavors.getBadgeStyle({ track: props.details.track });
  const $details = createMemo(() => {
    return props.details;
  });
  const $team_info = createMemo(() => {
    return props.team_info;
  });
  const $status = createMemo(() => {
    const status = $details()?.status.toLowerCase();
    return {
      value: $details()?.status,
      complete: status === "complete",
      incomplete: status === "in-complete",
    };
  });
  async function onSendInvite() {
    const requester_email = global.api.auth.events.getUserEmail();
    const email = $details()?.members?.find((member: membersProps) => member?.role === "leader")?.email;
    const data = {
      requester_email: requester_email,
      receiver_email: email,
      status: "pending",
    };
    return await request.post(JSON.stringify(data)).then(() => {
      global.store.actions.toast.pushToast({
        type: "success",
        message: "Invite Sent",
      });
    });
  }

  return (
    <div class="flex flex-col w-full min-h-320px h-310px pb-2 bg-bg rounded-xl border-1 border-solid border-border-card overflow-hidden <sm:(h-150px)">
      {/* thubmnail */}
      <p class="flex flex-col w-full min-h-120px font-bold text-16px overflow-hidden <sm:py-0 ">
        <img
          class="w-full h-full object-cover"
          src={$details().thumbnail ?? "/images/placeholders/cover.png"}
          alt="team_custom_logo"
        />
      </p>
      {/* team name, status and track */}
      <div class="flex flex-col w-full min-h-50px justify-center items-start text-start px-2 pt-2 pb-3 overflow-hidden">
        <span class="flex flex-row w-full min-h-35px overflow-y-hidden overflow-x-auto whitespace-nowrap">
          {$details()?.team_name ?? "No team name"}
        </span>
        <div class="flex flex-row justify-between w-full h-full">
          <p class="flex flex-row text-14px items-center gap-x-1">
            <span class={"w-9px h-9px rounded-full" + " " + ($status().complete ? "bg-success" : "bg-warn")} />
            <span
              class={
                //
                "" + " " + ($status().complete ? "text-success" : "text-warn")
              }
            >
              <Switch>
                <Match when={$details()?.status === "In-Complete"}>Member Scouting</Match>
                <Match when={$details()?.status === "Active"}>Almost Full</Match>
                <Match when={$details()?.status === "Completed"}>Fully Occupied</Match>
                <Match when={true}>No Status</Match>
              </Switch>
            </span>
          </p>
          <p style={track.style} class="bg-warn-shade text-warn text-13px py-1 px-2 capitalize rounded-md">
            {$details()?.track ?? "No track"}
          </p>
        </div>
      </div>
      {/* brief */}
      <span class="flex min-h-50px text-16px px-2 overflow-auto">{$details()?.brief ?? "No team brief"}</span>
      {/* images and button */}
      <div class="flex min-h-50px items-center justify-between px-2">
        <ImagesStacked items={$details().members} />
        <Button
          //
          controls={{}}
          // class={"form-btn !mt-1 " + " " + (props.team != undefined ? "disabled:(!bg-error-shade text-error)" : "")}
          class={"form-btn !w-120px !h-40px !text-16px whitespace-nowrap" + " "}
          // triggers={{
          //   manualStatus: props.team == undefined ? "valid" : "invalid",
          // }}
          onSubmit={(e) => {
            return onSendInvite();
          }}
          // statusInvalid={"Part Of Team " + String(props.team)}
          disabled={$team_info() != undefined}
          statusValid="Send Request"
        />
      </div>
    </div>
  );
}
